/**
 * /en/admin/structure/paragraphs_type/form_element_telephone/fields
 */

import { ATTRIBUTES, DOM_EVENTS } from "../constants/html-constants.es6.js"
import FormElementParagraph from "@js/paragraphs/form-element-paragraph.es6.js";
import LabelFormElementParagraphField
  from "@js/fields/form-element-label-paragraph-field.es6.js";
import RegexUtils from "@js/utils/regex-utils.es6.js";

export default class TelephoneFormElementParagraph extends FormElementParagraph {
  get label() {
    return new LabelFormElementParagraphField({
      machineName: 'field_form_label',
      parentElement: this,
    });
  }

  get rawValue() {
    return this.element.$().val();
  }

  get value() {
    const value = this.rawValue;
    if (!value) {
      return null;
    }

    return RegexUtils.getDigits(value);
  }

  get minLength() {
    const minLengthString = this.element.$().attr(ATTRIBUTES.MINLENGTH);
    return minLengthString ? Number(minLengthString) : null;
  }

  get maxLength() {
    const maxLengthString = this.element.$().attr(ATTRIBUTES.MAXLENGTH);
    return maxLengthString ? Number(maxLengthString) : null;
  }

  constructor({ parentElement }) {
    super({
      machineName: 'form_element_telephone',
      parentElement,
    });
  }

  initialize() {
    const $input = this.element.$();

    $input.on(DOM_EVENTS.INPUT, event => {
      TelephoneFormElementParagraph.#format(event);
    });
  }

  static #format(event) {
    const formattedValue = RegexUtils.formatPhoneNumber(event.target.value);
    event.target.value = formattedValue;
  }

  validate() {
    const valid = super.validate();
    if (!valid) {
      return false;
    }

    const value = this.rawValue;
    if (value) {
      const minLength = this.minLength;
      if ((minLength || minLength === 0) && value.length < minLength) {
        return false;
      }

      const maxLength = this.maxLength;
      if ((maxLength || maxLength === 0) && value.length > maxLength) {
        return false;
      }
    }

    return true;
  }
}

(() => {
  const telephoneFormElement = new TelephoneFormElementParagraph({});
  telephoneFormElement.onRendered(async () => {
    telephoneFormElement.initialize();
  });
})(Drupal);
